import { BaseMessageInfo } from "./BaseMessageInfo";
import { InvoiceBus } from "./InvoiceBus";

export class InvoiceMessageInfo extends BaseMessageInfo
{
    invoice: InvoiceBus;
    existingInvoiceNumber: string;
    dispatchHasInvoiceNumberLinked: boolean;
    wasDispatchStatusUpdated: boolean;
    invoiceDate: Date;
    routing: string;
    duplicatePO: boolean;
    invoiceWasSaved: boolean;
    getEmpRate: boolean;
    errorCode: number;
}
